// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItem from "app/models/TimelineItem";

import "./MapTimelineItem.scss";
import mapsIcon from "app/assets/images/maps-icon.png";

type Props = {
    item: TimelineItem
};

@observer
export default class MapTimelineItem extends React.Component<Props> {
    render() {
        return (
            <div
                style={{ backgroundImage: `url(${mapsIcon})` }}
                className="MapTimelineItem"
                alt="Map timeline item"
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineItem/MapTimelineItem/MapTimelineItem.js